function App(window, document) {

    this.Globals = require('./config/cached-elements');

    this.Globals.$document.on('ready', function () {

        require('./components/page-transitions').init();

    });

    this.Globals.$document.on('ready pjax:end', function () {

        //  Priority Load
        require('./components/foundation').init();
        require('./components/open-new-tab').init();

        //  Individual components
        require('./components/contact-map').init();
        require('./components/content-tabs').init();
        require('./components/cookie-notice.js').init();
        require('./components/filter').init();
        require('./components/form').init();
        require('./components/header').init();
        require('./components/locations').init();
        require('./components/partners').init();
        require('./components/popup').init();
        require('./components/scroller').init();
        require('./components/slider').init();
        require('./components/trigger').init();
        require('./components/waypoints').init();
        require('./components/autocomplete').init();

    });

}

window.App = new App(this, document);
